import { render, staticRenderFns } from "./DashboardNav.vue?vue&type=template&id=50a31f9e&scoped=true&"
import script from "./DashboardNav.vue?vue&type=script&lang=js&"
export * from "./DashboardNav.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNav.vue?vue&type=style&index=0&id=50a31f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a31f9e",
  null
  
)

export default component.exports